import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M8 13L5 16L8 19" vectorEffect="non-scaling-stroke" />
		<Path d="M20 8H4M20 16H10.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
